import { useEffect, useRef, useState } from 'react';
import { ENUM_CARD_EVENT_METRIC } from '@/modules/playground/enums/card-event-metric.enum';
import { useAnalytics } from './useAnalytics.hook';

type UseCardImpressionOptions = {
  cardId: string;
};

const useCardImpression = ({ cardId }: UseCardImpressionOptions) => {
  const { captureCardMetric } = useAnalytics();

  const [hasTracked, setHasTracked] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current || hasTracked) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          captureCardMetric(cardId, ENUM_CARD_EVENT_METRIC.IMPRESSION);
          setHasTracked(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [cardId, hasTracked]);

  return ref;
};

export default useCardImpression;
